/* istanbul ignore file */
// libs
import { useParams } from 'react-router-dom';
// components
import { Show } from 'framework/show';
import { ShowSection, BigSectionRow, SectionRow, ShowPageLayout } from 'framework/ui/layout';
import { ReplaceUrlWithLink } from 'framework/utils';
import { AddressField, HtmlField, PhoneField, TextField, ListField, EmailField, LinkField } from 'framework/ui/field';
import { AttachmentsListField } from 'domain/shared/artifact/field';
import { LeadLinkField } from 'domain/shared/lead';
import ContactsMenu from 'domain/sales/contact/shared/ContactsMenu';
import EditContactButton from 'domain/sales/contact/shared/button/EditContactButton';
import DeleteContactButton from 'domain/sales/contact/shared/button/DeleteContactButton';
import ContactEntityHeader from 'domain/sales/contact/shared/ContactEntityHeader';
import { AccountLinkField } from 'domain/shared/account';
import SingleContactsBreadcrumbs from 'domain/sales/contact/shared/SingleContactsBreadcrumbs';
// services
import useContactService from 'domain/sales/contact/shared/contactService';
import { UPDATE } from 'domain/shared/core/permissions';

const ContactViewPage = () => {
  const { id = '' } = useParams<Dictionary<string>>();
  const { getById } = useContactService();

  const buttons = [
    <EditContactButton key="edit-contact" permissionToCheck={UPDATE} />,
    <DeleteContactButton key="delete-contact" permissionToCheck={UPDATE} />,
  ];

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        headerButtons={buttons}
        menu={<ContactsMenu />}
        breadcrumbs={<SingleContactsBreadcrumbs />}
        entityHeader={<ContactEntityHeader />}
        hasSeparateSections
      >
        <ShowSection title="Contact information">
          <SectionRow>
            <ListField source="emails">
              <EmailField />
            </ListField>
            <PhoneField source="phoneNumber" label="Phone 1" />
            <PhoneField source="mobilePhoneNumber" label="Phone 2" />
            <LinkField source="linkedInLink" label="LinkedIn" />
            <AccountLinkField
              label="Account name"
              source="accountName"
              idSource="accountId"
              isInternal={false}
              isVisible={(data: any) => data.getValueBySource('accountId') && data.getValueBySource('accountName')}
            />
          </SectionRow>
          <SectionRow>
            <TextField source="title" />
            <LeadLinkField
              label="Converted from"
              idSource="convertedFromId"
              nameSource="convertedFromName"
              isVisible={(data: any) => data.getValueBySource('convertedFromId')}
            />
          </SectionRow>
        </ShowSection>
        <ShowSection title="Address information">
          <AddressField source="address" />
        </ShowSection>
        <ShowSection title="Description">
          <BigSectionRow>
            <ReplaceUrlWithLink>
              <HtmlField source="description" label="" />
            </ReplaceUrlWithLink>
          </BigSectionRow>
        </ShowSection>
        <ShowSection title="Attachments">
          <AttachmentsListField source="attachmentsIds" label="" />
        </ShowSection>
        <ShowSection title="Additional information" isVisible={data => data.getValueBySource('additionalInformation')}>
          <TextField source="additionalInformation" label="" />
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default ContactViewPage;
